import { withPropsState } from '../../ErrorPopup/PropStateErrorPopup';
import { DefaultErrorPopup as BaseDefaultErrorPopup } from './DefaultErrorPopup';

export const DefaultErrorPopup = withPropsState(BaseDefaultErrorPopup);
